import { useEffect, useState } from "react";
import api from "@/lib/api";
import { CalendarHeart, Loader2 } from "lucide-react";

export default function BookAppointment() {
  const [url, setUrl] = useState(null);

  useEffect(() => {
    api.get("/settings/public")
      .then((r) => setUrl(r.data.calendly_link || "https://calendly.com/your-link"))
      .catch(() => setUrl("https://calendly.com/your-link"));
  }, []);

  useEffect(() => {
    if (!url) return;
    const script = document.createElement("script");
    script.src = "https://assets.calendly.com/assets/external/widget.js";
    script.async = true;
    document.body.appendChild(script);
    return () => { document.body.removeChild(script); };
  }, [url]);

  return (
    <div className="max-w-6xl mx-auto px-5 sm:px-8 py-24">
      <div className="max-w-2xl mb-12">
        <span className="text-xs uppercase tracking-[0.2em] text-muted-foreground">Book an Appointment</span>
        <h1 className="font-serif text-4xl sm:text-5xl tracking-tight mt-3 mb-4">Sit with a practitioner.</h1>
        <p className="text-muted-foreground leading-relaxed">Walk through your frequency map one-to-one. Pick a time that suits you below.</p>
      </div>

      <div className="rounded-2xl border border-border bg-card overflow-hidden min-h-[500px]">
        {url === null ? (
          <div className="py-32 grid place-items-center"><Loader2 className="animate-spin text-primary" strokeWidth={1.5} /></div>
        ) : (
          <div className="calendly-inline-widget" data-url={url} style={{ minWidth: "320px", height: "700px" }} data-testid="calendly-widget" />
        )}
      </div>

      <div className="mt-8 rounded-2xl border border-primary/20 bg-primary/5 p-6 flex items-start gap-4">
        <CalendarHeart className="text-primary shrink-0" strokeWidth={1.5} />
        <p className="text-sm text-muted-foreground">The booking link is managed by the team in Admin → Settings (<code className="text-primary">calendly_link</code>). If the scheduler doesn't load, it hasn't been set to a real Calendly link yet.</p>
      </div>
    </div>
  );
}
